import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  type: [
    {id: 1, name: 'HWS Gas Storage'},
    {id: 2, name: 'HWS Electric Storage'},
    {id: 3, name: 'HWS Gas Continuous Flow'},
    {id: 4, name: 'HWS Electric Continuous Flow'},
    {id: 5, name: 'HWS Solar Gas Boosted'},
    {id: 6, name: 'HWS Solar Electric Boosted'},
    {id: 7, name: 'HWS Heat Pump'},
    {id: 8, name: 'HWS Boiling / Chilled'},
    {id: 9, name: 'HWS Commercial'},
    {id: 10, name: 'Tap Mixer Basin'},
    {id: 11, name: 'Tap Mixer Sink'},
    {id: 12, name: 'Tap Mixer Sink with Pull Out'},
    {id: 13, name: 'Tap Mixer Wall'},
    {id: 14, name: 'Tap Mixer Wall & Spout Combined'},
    {id: 15, name: 'Tap Mixer Bath Floor Mounted'},
    {id: 16, name: 'Tap Wall Top Assembly'},
    {id: 17, name: 'Tap Hob Top Assembly'},
    {id: 18, name: 'Tap Set Basin'},
    {id: 19, name: 'Tap Set Shower'},
    {id: 20, name: 'Tap Set Bath'},
    {id: 21, name: 'Tap Set Sink'},
    {id: 22, name: 'Tap Set Washing Machine Stop'},
    {id: 23, name: 'Tap Outlet Basin'},
    {id: 24, name: 'Tap Outlet Shower Hand / Head / Arm'},
    {id: 25, name: 'Tap Outlet Shower Rail'},
    {id: 26, name: 'Tap Outlet Bath / Spa'},
    {id: 27, name: 'Tap Outlet Sink'},
    {id: 28, name: 'Tap Pillar'},
    {id: 29, name: 'Tap Filter'},
    {id: 30, name: 'Tap Bidet'},
    {id: 31, name: 'Tap Care / Commercial'},
    {id: 32, name: 'Toilet CC Suite'},
    {id: 33, name: 'Toilet CC Back to Wall Suite'},
    {id: 34, name: 'Toilet Linked Suite'},
    {id: 35, name: 'Toilet Skew Suite'},
    {id: 36, name: 'Toilet Cistern'},
    {id: 37, name: 'Toilet Cistern in Wall Concealed'},
    {id: 38, name: 'Toilet Pan'},
    {id: 39, name: 'Toilet Seat'},
    {id: 40, name: 'Toilet Bidet'},
    {id: 41, name: 'Toilet Urinal'},
    {id: 42, name: 'Toilet Smart'},
    {id: 43, name: 'Toilet Care / Commercial'},
    {id: 44, name: 'Sink Single Bowl'},
    {id: 45, name: 'Sink Double Bowl'},
    {id: 46, name: 'Sink Granite'},
    {id: 47, name: 'Sink Ceramic'},
    {id: 48, name: 'Trough Single Bowl'},
    {id: 49, name: 'Trough Double Bowl'},
    {id: 50, name: 'Trough / Sink & Cabinet'},
    {id: 51, name: 'Trough / Sink Commercial'},
    {id: 52, name: 'Vanity Unit Floor Mounted Single Bowl'},
    {id: 53, name: 'Vanity Unit Floor Mounted Double Bowl'},
    {id: 54, name: 'Vanity Unit Wall Hung Single Bowl'},
    {id: 55, name: 'Vanity Unit Wall Hung Double Bowl'},
    {id: 56, name: 'Vanity Top'},
    {id: 57, name: 'Basin Above Counter / Vessel'},
    {id: 58, name: 'Basin Inset'},
    {id: 59, name: 'Basin Semi Recessed'},
    {id: 60, name: 'Basin Under Counter'},
    {id: 61, name: 'Basin Wall Mounted'},
    {id: 62, name: 'Basin Pedestal / Shroud'},
    {id: 63, name: 'Basin Floor Mounted'},
    {id: 64, name: 'Basin / Vanity Care / Commercial'},
    {id: 65, name: 'Bath Freestanding'},
    {id: 66, name: 'Bath Back to Wall'},
    {id: 67, name: 'Bath Inset'},
    {id: 68, name: 'Bath Corner'},
    {id: 69, name: 'Bath / Spa Screen'},
    {id: 70, name: 'Spa Freestanding'},
    {id: 71, name: 'Spa Inset'},
    {id: 72, name: 'Spa Corner'},
    {id: 73, name: 'Shower Base'},
    {id: 74, name: 'Shower Screen Framed'},
    {id: 75, name: 'Shower Screen Semi Frameless'},
    {id: 76, name: 'Shower Screen Frameless'},
    {id: 77, name: 'Shower Outdoor'},
    {id: 78, name: 'Floor Waste / Channel'},
    {id: 79, name: 'Plug & Waste'},
    {id: 80, name: 'Bottle Trap'},
    {id: 81, name: 'Bathroom Appliance'},
    {id: 82, name: 'Bathroom Accessory'},
    {id: 83, name: 'Dishwasher'},
    {id: 84, name: 'Washing Machine'},
    {id: 85, name: 'Cooktop'},
    {id: 86, name: 'Upright Cooker'},
    {id: 87, name: 'Rangehood'},
    {id: 88, name: 'Waste Disposer'},
    {id: 89, name: 'Kitchen Appliance Other'},
    {id: 90, name: 'Pump Multistage / Pressure'},
    {id: 91, name: 'Pump Jet'},
    {id: 92, name: 'Pump Submersible'},
    {id: 93, name: 'Pump Controller'},
    {id: 94, name: 'Pump Circulation'},
    {id: 95, name: 'Tank Rainwater'},
    {id: 96, name: 'Tank Septic'},
    {id: 97, name: 'Lifting Station'},
    {id: 98, name: 'Macerator'},
    {id: 99, name: 'Grease Trap'},
    {id: 100, name: 'Ducted Heater'},
    {id: 101, name: 'Wall Furnace / Space Heater'},
    {id: 102, name: 'Portable Space Heater'},
    {id: 103, name: 'Evaporative Cooling'},
    {id: 104, name: 'Heating & Cooling Other'},
    {id: 105, name: 'Refrigeration'},
    {id: 106, name: 'Irrigation'},
    {id: 107, name: 'Pool & Spa'},
    {id: 108, name: 'Fire'}
  ],
  suppliers: [
    {id: 1, name: 'Bunnings'},
    {id: 2, name: 'Mitre 10'},
    {id: 3, name: 'Reece'},
    {id: 4, name: 'Other'}
  ],
  brands: [
    {id: 167, name: '3Monkeez'},
    {id: 1, name: 'Abey'},
    {id: 2, name: 'ADP'},
    {id: 3, name: 'AFA'},
    {id: 4, name: 'Akril'},
    {id: 5, name: 'Alape'},
    {id: 6, name: 'American Standard'},
    {id: 168, name: 'Apricus'},
    {id: 9, name: 'Aquamax'},
    {id: 133, name: 'Aquapure'},
    {id: 134, name: 'Arco'},
    {id: 135, name: 'Ardent'},
    {id: 7, name: 'Argent'},
    {id: 8, name: 'Armitage Shanks'},
    {id: 136, name: 'Auspex'},
    {id: 10, name: 'AXA'},
    {id: 11, name: 'Base'},
    {id: 12, name: 'Bastow'},
    {id: 13, name: 'Bermuda'},
    {id: 137, name: 'Billi'},
    {id: 14, name: 'Blanco'},
    {id: 15, name: 'Bosch'},
    {id: 16, name: 'Bradflo'},
    {id: 130, name: 'Braemar'},
    {id: 138, name: 'Bridgland'},
    {id: 17, name: 'Brita'},
    {id: 18, name: 'Britex'},
    {id: 19, name: 'Brodware'},
    {id: 20, name: 'BWT'},
    {id: 21, name: 'Caravelle'},
    {id: 22, name: 'Caroma'},
    {id: 169, name: 'Cavagna'},
    {id: 23, name: 'CIBO'},
    {id: 24, name: 'Ciclon'},
    {id: 25, name: 'Clark'},
    {id: 139, name: 'Conex Banninger'},
    {id: 26, name: 'Cotto'},
    {id: 27, name: 'Creative'},
    {id: 28, name: 'Dadanco'},
    {id: 29, name: 'Davey'},
    {id: 30, name: 'Debba'},
    {id: 31, name: 'Decina'},
    {id: 170, name: 'Dektite'},
    {id: 32, name: 'Dorf'},
    {id: 140, name: 'Duopex'},
    {id: 141, name: 'Dura'},
    {id: 33, name: 'Dux'},
    {id: 171, name: 'Easydrain'},
    {id: 34, name: 'Enware'},
    {id: 35, name: 'Esatto'},
    {id: 36, name: 'Espire'},
    {id: 37, name: 'Estilo'},
    {id: 38, name: 'Everhard'},
    {id: 39, name: 'Everhot'},
    {id: 142, name: 'EvoPEX'},
    {id: 40, name: 'Ezyfix'},
    {id: 41, name: 'Fienza'},
    {id: 42, name: 'Fima'},
    {id: 43, name: 'Fisher'},
    {id: 172, name: 'Fix-A-Tap'},
    {id: 44, name: 'Flexispray'},
    {id: 45, name: 'Flotec'},
    {id: 143, name: 'Fluidmaster'},
    {id: 46, name: 'Fowler'},
    {id: 47, name: 'Franke'},
    {id: 48, name: 'Geberit'},
    {id: 49, name: 'Gentec'},
    {id: 50, name: 'Gessi'},
    {id: 51, name: 'Graf'},
    {id: 52, name: 'Grohe'},
    {id: 53, name: 'Grundfos'},
    {id: 144, name: 'Guyco'},
    {id: 54, name: 'Hansa'},
    {id: 55, name: 'Hansgrohe'},
    {id: 145, name: 'Haron'},
    {id: 56, name: 'Heirloom'},
    {id: 57, name: 'Henden'},
    {id: 58, name: 'Hideaway'},
    {id: 59, name: 'Hyjet'},
    {id: 60, name: 'Insinkerator'},
    {id: 61, name: 'Issy'},
    {id: 62, name: 'Ivy'},
    {id: 146, name: 'John Guest'},
    {id: 63, name: 'Johnson'},
    {id: 64, name: 'Kaden'},
    {id: 65, name: 'Kado'},
    {id: 66, name: 'Kaldewei'},
    {id: 147, name: 'Kembla'},
    {id: 67, name: 'Kinetic'},
    {id: 68, name: 'Kirra'},
    {id: 69, name: 'Kochi'},
    {id: 173, name: 'Kolo'},
    {id: 70, name: 'Lago'},
    {id: 71, name: 'Laufen'},
    {id: 72, name: 'Marbletrend'},
    {id: 73, name: 'Marquis'},
    {id: 148, name: 'Melro'},
    {id: 74, name: 'Memo'},
    {id: 75, name: 'Meridian'},
    {id: 76, name: 'Methven'},
    {id: 77, name: 'Metro'},
    {id: 149, name: 'Milena'},
    {id: 78, name: 'Milli'},
    {id: 79, name: 'Mintori'},
    {id: 80, name: 'Mixx'},
    {id: 81, name: 'Mizu'},
    {id: 82, name: 'Mobi'},
    {id: 83, name: 'Mondella'},
    {id: 84, name: 'Nero'},
    {id: 85, name: 'Nevanda'},
    {id: 86, name: 'Nicolazzi'},
    {id: 87, name: 'Nikles'},
    {id: 88, name: 'Nobili'},
    {id: 89, name: 'Noosa'},
    {id: 174, name: 'Norma'},
    {id: 90, name: 'Novelli'},
    {id: 175, name: 'Nugleam'},
    {id: 176, name: 'Nylex'},
    {id: 91, name: 'Oliveri'},
    {id: 92, name: 'Omega'},
    {id: 93, name: 'Omvivo'},
    {id: 150, name: 'Performa'},
    {id: 151, name: 'Philmac'},
    {id: 94, name: 'Phoenix'},
    {id: 152, name: 'Plasson'},
    {id: 95, name: 'Plastec'},
    {id: 177, name: 'Polychoice'},
    {id: 153, name: 'Polyslab'},
    {id: 96, name: 'Porcher'},
    {id: 97, name: 'Posh'},
    {id: 154, name: 'Promat'},
    {id: 98, name: 'Purmo'},
    {id: 178, name: 'Qtank'},
    {id: 99, name: 'Quoss'},
    {id: 100, name: 'Radiant'},
    {id: 101, name: 'Ram'},
    {id: 102, name: 'Raymor'},
    {id: 155, name: 'RBA'},
    {id: 131, name: 'Reece'},
    {id: 103, name: 'Reefe'},
    {id: 157, name: 'Rehau'},
    {id: 158, name: 'Reln'},
    {id: 104, name: 'Rheem'},
    {id: 105, name: 'Rinnai'},
    {id: 156, name: 'RMC'},
    {id: 159, name: 'Robert Gordon'},
    {id: 106, name: 'Roca'},
    {id: 179, name: 'Safetray'},
    {id: 107, name: 'Saniflo'},
    {id: 180, name: 'Saniform'},
    {id: 108, name: 'Scala'},
    {id: 160, name: 'Sharkbite'},
    {id: 109, name: 'Shaw & Mason'},
    {id: 110, name: 'Shaws'},
    {id: 161, name: 'Silverback'},
    {id: 111, name: 'Sime'},
    {id: 112, name: 'Sonia'},
    {id: 162, name: 'Soudal'},
    {id: 113, name: 'Stiebel Eltron'},
    {id: 181, name: 'Stormflex'},
    {id: 182, name: 'Stramit'},
    {id: 114, name: 'Stylus'},
    {id: 183, name: 'Sunmaster'},
    {id: 115, name: 'Sussex'},
    {id: 163, name: 'Sutton'},
    {id: 116, name: 'Technika'},
    {id: 117, name: 'Teknobili'},
    {id: 118, name: 'Thermann'},
    {id: 164, name: 'Tomson'},
    {id: 184, name: 'TTC'},
    {id: 119, name: 'Urinette'},
    {id: 120, name: 'Vada'},
    {id: 165, name: 'Veitch'},
    {id: 121, name: 'Venice'},
    {id: 122, name: 'Venini'},
    {id: 123, name: 'Vivid'},
    {id: 124, name: 'Vulcan'},
    {id: 132, name: 'Walraven'},
    {id: 185, name: 'WaterLine'},
    {id: 129, name: 'Westinghouse'},
    {id: 186, name: 'Wilson'},
    {id: 125, name: 'Wolfen'},
    {id: 128, name: 'Yeva'},
    {id: 166, name: 'Zetco'},
    {id: 126, name: 'Zip'},
    {id: 127, name: 'Other'}
  ],
  qty: [
    {id: 0, name: 0},
    {id: 1, name: 1},
    {id: 2, name: 2},
    {id: 3, name: 3},
    {id: 4, name: 4},
    {id: 5, name: 5},
    {id: 6, name: 6},
    {id: 7, name: 7},
    {id: 8, name: 8},
    {id: 9, name: 9}
  ],
  suppliers: [
    {id: 1, name: 'Reece'},
    {id: 2, name: 'Bunnings'},
    {id: 3, name: 'Mitre 10'},
    {id: 4, name: 'Other'}
  ]
}

export default {
  state,
  getters,
  mutations,
  actions
}
